import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';

const CardButtonProfile = ({
  title,
  description,
  to,
  children,
  image,
  typeCard = 'action',
  cardContentProps = {},
  style = {},
}) => {
  const TagTypeCard = (() => {
    switch (typeCard) {
      case 'action':
        return CardActionArea;
      case 'content':
        return CardContent;
      default:
        return CardActionArea;
    }
  })();

  const linkData = () => {
    if (typeCard === 'content') return {};
    if (typeCard === 'action') {
      return {
        component: Link,
        to: to || '/',
        ariaLabel: `Ver el perfil de ${title}`,
      };
    }
  };

  return (
    <Card style={style}>
      <TagTypeCard sx={{ borderRadius: '10px' }} {...linkData()}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
          }}
        >
          <CardMedia>
            <Avatar sx={{ mt: '16px', width: 80, height: 80 }} />
          </CardMedia>
          <CardContent {...cardContentProps}>
            {title && (
              <Typography
                gutterBottom
                variant='h6'
                component='h2'
                textAlign={'center'}
                sx={{ fontWeight: 'bold' }}
              >
                {title || ''}
              </Typography>
            )}
            {description && (
              <Typography variant='body2' color='textSecondary' component='p' textAlign={'center'}>
                {description}
              </Typography>
            )}
            {children}
          </CardContent>
        </Box>
      </TagTypeCard>
    </Card>
  );
};

export default CardButtonProfile;
